const blackColors = {
    black0: '#000000',
    black1: '#121212'
};
const grayColors = {
    gray1: '#4b4b4b',
    gray2: '#e5e7eb',
    gray3: '#CDCDCD',
    gray4: '#a5a5a5',
    gray5: '#787575',
    gray6: '#f3f4f6',
    gray7: '#EAEAEA'
};
const whiteColors = {
    white0: '#ffffff',
    white1: '#eeeeee'
};
const primaryColors = {
    light: '#121212',
    main: '#121212',
    dark: '#121212',
    contrastText: '#fff'
};
const secondaryColors = {
    light: '#ec407a',
    main: '#f50057',
    dark: '#c2185b',
    contrastText: '#fff'
};
const textColors = {
    textDark: blackColors.black1,
    textGray: grayColors.gray5,
    textGrayDisabled: grayColors.gray5,
    textWhite: whiteColors.white1
};
const colors = {
    ...blackColors,
    ...grayColors,
    ...whiteColors,
    ...textColors,
    theme: {
        primary: {
            ...primaryColors
        },
        secondary: {
            ...secondaryColors
        }
    }
};
export { colors };
